import { injectIntl } from "react-intl";
import React, { useEffect, useState } from "react";
import TableHeader from "src/components/TableHeader";
import {
    EMAIL_LIST_TABLE_TITLE_SORT, EMAIL_LIST_TABLE_TITLE_WIDTHS, EMAIL_LIST_TABLE_TITLES,
} from "src/helpers/Constants";
import Pagination from "src/components/Pagination";
import { ListType, OperationType, ReputationBackground, EmailListTableSortType } from "src/helpers/Enums";

const EmailListTable = (props) => {

    const [currentPage, setCurrentPage] = useState(1)
    const [totalPages, setTotalPages] = useState(1)
    const [sortedList, setSortedList] = useState(props.list)

    useEffect(() => {
        if (props.list?.length > 6) {
            setSortedList(props.list?.slice((currentPage - 1) * 11, (currentPage * 11)))
            setTotalPages(Math.ceil(props.list?.length / 11))
        } else {
            setSortedList(props.list)
        }
    }, [props.list, currentPage])

    const handlePageChange = (page) => {
        setCurrentPage(page);
    }

    return (
        <div className={ "w-full flex flex-col justify-between h-full" }>
            <div className={ "flex flex-col gap-3" }>
                <TableHeader titles={ EMAIL_LIST_TABLE_TITLES } widths={ EMAIL_LIST_TABLE_TITLE_WIDTHS }
                             sort={ EMAIL_LIST_TABLE_TITLE_SORT } sortedList={ sortedList }
                             sortType={ EmailListTableSortType }
                             setSortedList={ setSortedList }/>
                <div className="TableWrapper">
                    <table className="Table">
                        <tbody>
                        { sortedList?.map((item, index) => (
                            <tr key={ index } className="border-b h-[60px] hover:bg-[#F6F6F9]">
                                <td className="py-2 px-4 border-r text-[12px] leading-[14px] font-semibold"
                                    style={ {width: EMAIL_LIST_TABLE_TITLE_WIDTHS[0]} }>
                                    <div className={ "flex gap-3 items-center" }>
                                        <div
                                            className={ item.is_active ? "ActiveBox" : "InactiveBox" }>{ item.is_active ? "Active" : "Inactive" }</div>
                                        <div className={ "flex flex-col gap-1" }>
                                            <div>{ item.name }</div>
                                            <div className={ "ListsFromNameLine" }>
                                                <img alt={ "Logo" } src={ "/media/icons/fromName.svg" }
                                                     className={ "w-3 h-3" }/>
                                                <div>{ item.from_name }</div>
                                            </div>
                                        </div>
                                    </div>
                                </td>
                                <td className="py-2 px-4 border-r text-[12px] leading-[14px] font-semibold"
                                    style={ {width: EMAIL_LIST_TABLE_TITLE_WIDTHS[1]} }>
                                    <div className={ "flex gap-1 items-center" }>
                                        <div className={ item.segment === "Live" ? "ListSegmentLive" : "ListSegmentRepair" }></div>
                                        <div>{item.segment}</div>
                                    </div>
                                </td>
                                <td className="py-2 px-4 border-r text-[12px] leading-[14px] font-semibold"
                                    style={ {width: EMAIL_LIST_TABLE_TITLE_WIDTHS[2]} }>{ item.slot }</td>
                                <td className="py-2 px-4 border-r text-[12px] leading-[14px] font-semibold"
                                    style={ {width: EMAIL_LIST_TABLE_TITLE_WIDTHS[3]} }>{ item.strategy_id?.name }</td>
                                <td className="py-2 px-4 border-r text-[12px] leading-[14px] font-semibold"
                                    style={ {width: EMAIL_LIST_TABLE_TITLE_WIDTHS[4]} }>
                                    { item.tag_ids?.length > 0 &&
                                        <div className={ "flex items-center justify-center" }>
                                            <div className={ "EmailTableTag" }>+{ item.tag_ids?.length }</div>
                                        </div>
                                    }
                                </td>
                                <td className={ "py-2 px-4 border-r text-[12px] leading-[14px] font-semibold" }
                                    style={ {width: EMAIL_LIST_TABLE_TITLE_WIDTHS[5]} }>
                                    <div className={ "Reputation" }
                                         style={ {backgroundColor: ReputationBackground[item?.ip_reputation]} }>
                                        { item.ip_reputation ? item.ip_reputation?.charAt(0).toUpperCase() + item.ip_reputation?.slice(1).toLowerCase() : "" }
                                    </div>
                                </td>
                                <td className="py-2 px-4 border-r text-[12px] leading-[14px] font-semibold"
                                    style={ {width: EMAIL_LIST_TABLE_TITLE_WIDTHS[6]} }>
                                    <div className={ "Reputation" }
                                         style={ {backgroundColor: ReputationBackground[item?.domain_reputation]} }>
                                        { item.domain_reputation ? item.domain_reputation?.charAt(0).toUpperCase() + item.domain_reputation?.slice(1).toLowerCase() : "" }
                                    </div>
                                </td>
                                <td className="py-3 px-4 flex justify-center items-center">
                                    <button className="StrategyEditButton"
                                            onClick={ () => props.handleOpenNewList(OperationType.UPDATE, item) }>
                                        <img alt={ "Logo" } src={ "/media/icons/editIcon.svg" }
                                             className={ "w-4 h-4" }/>
                                    </button>
                                    <button className="StrategyDeleteButton"
                                            onClick={ () => props.handleOpenDeleteStrategy(ListType.Email, item) }>
                                        <img alt={ "Logo" } src={ "/media/icons/deleteIcon.svg" }
                                             className={ "w-4 h-4" }/>
                                    </button>
                                </td>
                            </tr>
                        )) }
                        </tbody>
                    </table>
                </div>
            </div>
            <Pagination currentPage={ currentPage } totalPages={ totalPages } onPageChange={ handlePageChange }/>
        </div>
    );
}

export default injectIntl(EmailListTable);
